module.exports = __webpack_public_path__ + "static/media/logo-net-new.c543a6dd.png";